"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VerticalTab = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const elements_1 = require("../../elements");
const VerticalTabContext_1 = require("./VerticalTabContext");
const lib_1 = require("../../lib");
const VerticalTab = ({ children, icon, name }) => {
    const { onTabClick, activeTab } = (0, react_1.useContext)(VerticalTabContext_1.VerticalTabContext);
    const handleTabClick = (0, react_1.useCallback)(() => {
        if (onTabClick) {
            onTabClick(activeTab === name ? undefined : name);
        }
    }, [activeTab, onTabClick]);
    return ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: (0, lib_1.bem)('vertical-tabs__tab') }, { children: (0, jsx_runtime_1.jsx)(elements_1.Button, Object.assign({ secondary: activeTab !== name, secondaryBlue: activeTab === name, icon: icon, iconButton: !children, onClick: handleTabClick, size: "2.5" }, { children: children }), void 0) }), void 0));
};
exports.VerticalTab = VerticalTab;
//# sourceMappingURL=VerticalTab.js.map